import './solicitudes.css';
export function EstadoSolicitud({ estado, estadoCompleto, estados = [] }) {
  let texto = '';
  let background = '';
  if (estado === 904) {
    const estadoObj = estados.find(e => e.id === estadoCompleto);
    texto = estadoObj ? estadoObj.nombre : 'CARGADA';
    background = estadoObj ? estadoObj.hexa : '#82f1cd';
  } else {
    switch (estado) {
      case 901:
        texto = 'SIN CARGAR';
        break;
      case 902:
        texto = 'PENDIENTE DE APROBACION';
        break;
      case 903:
        texto = 'DEVOLUCIÓN';
        break;
      case 905:
        texto = ' REINGRESO';
        break;
      default:
        texto = '';
    }
  }
  return (
    <span className={estado !== 904 ? `estadoBody estado${estado}` : 'estadoBody'} style={estado === 904 ? { backgroundColor: background, color: 'white' } : undefined}>
      {texto}
    </span>
  );
}
